import React from 'react';

const AuthzPermissionGroupMappingFormModal = React.lazy(() => import('../components/FormModal'));
const authzPermissionGroupMappingModalRegistry = {
    core_authzPermissionGroupMappingId: AuthzPermissionGroupMappingFormModal
};
export default authzPermissionGroupMappingModalRegistry;
